import React, { Component } from "react";
import { connect } from "react-redux";
import { OutlinedInput } from "@mui/material";
import { withLocalizer } from "utilities/withLocalizer";
import { updateCustomQuote } from "services/customQuote/customQuote.service";
import commonUtilities from "utilities/common";

import "../../customize.scss";

export class CustomizeQuoteStepSix extends Component {
    constructor(props) {
        super(props);
        this.state = {
            additionalRequirements: this.props.customQuote?.data?.additionalRequirements ?? ""
        };
    }

    handleBlur = (event) => {
        let { customQuote } = this.props;
        
        this.props.dispatch(updateCustomQuote({ 
            ...customQuote?.data,
            additionalRequirements: commonUtilities.cleanContent(event.target.value)
        }));
    };
    handleChange = (event) => {
        let { additionalRequirements } = this.state;
        additionalRequirements = event.target.value;
        this.setState({ additionalRequirements });
    };
    
    render() {
        const { data, customQuote, events, errors } = this.props;
        const { currentStep } = data;
        if (currentStep !== 6) {
            return null;
        }
        let additionalRequirements = this.state.additionalRequirements;
        return (
            <>
                {customQuote?.data ? 
                    <div className="step-editor">
                        <div className="step-heading">
                            <h4>{ this.props.localize("qma-custom-quote-step-6-heading") }</h4>
                            <div>
                                { this.props.localize("qma-custom-quote-step-6-intro") }
                            </div>
                        </div>
                        <div className="custom-quote-editor-container margin-top-2x">
                            <div className="custom-quote-editor-panel-wrapper">
                                <div className="custom-quote-editor-panel important-information">
                                    <div className="quote-information-editor important-information">
                                        <OutlinedInput
                                            multiline={true}
                                            fullWidth={true}
                                            value={additionalRequirements}
                                            rows={5}
                                            placeholder={ this.props.localize("qma-add-content-here") }
                                            type="text"
                                            name="additional-requirements"
                                            id="outlined-additional-requirements"
                                            onBlur={(event) => this.handleBlur(event)}
                                            onChange={(event) => this.handleChange(event)}
                                            aria-describedby="outlined-additional-requirements"
                                        />
                                    </div>
                                </div>        
                            </div>
                        </div>
                    </div>
                    : null
                }
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    customQuote: state.customQuote
});

export default connect(mapStateToProps)(withLocalizer(CustomizeQuoteStepSix));
